import startCase from 'lodash/startCase';
import { AvailableBasePathTypes } from '../../../types/common';
import Cookie from '../../../ports-frontend/Cookie';
import {
  GAMING_ROLLOUT_COOKIE_NAME,
  BASE_PATH_TO_COUNTRY_NAME_MAP,
} from '../constants';
import { trackGamingRolloutVisit } from '../../../model/tracking';

interface ScopeType {
  scope: {
    locale: AvailableBasePathTypes;
    group: 'control' | 'variant';
    date: string;
    split: number;
    vertical: 'games' | 'live-casino' | 'casino';
  };
}

export const trackGamingRollout = async () => {
  const data = await Cookie.get(GAMING_ROLLOUT_COOKIE_NAME);

  if (data) {
    try {
      const { scope }: ScopeType = JSON.parse(data);
      const isControlGroup = scope.group === 'control';
      const countryName = scope.locale
        ? BASE_PATH_TO_COUNTRY_NAME_MAP[scope.locale]
        : '';
      const countryNamePrefix =
        scope.locale === 'en-gb' ? 'UK' : `ROW_${countryName}`;

      const payload = {
        date: scope.date,
        split: scope.split,
        countryNamePrefix,
        verticalName: startCase(scope.vertical).replace(' ', ''),
        segmentType: isControlGroup ? 'Control' : 'Variant',
      };

      trackGamingRolloutVisit(payload);
    } catch (e) {
      console.error(`Incorrect '${GAMING_ROLLOUT_COOKIE_NAME}' cookie data.`);
    }
  }
};
